import * as THREE from 'three';
import { World } from './World';
import { Npc } from '../character/Npc';
import { Car } from '../vehicles/Car';
import { NpcSpawnService } from './NpcSpawnService';
import { CopCarBehaviour } from '../character/ai/CopCarBehaviour';

const CAR_MODEL_PATH = '../../assets/police-car.glb';

export class CopCarSpawnPoint {
    constructor(
        private readonly position: THREE.Vector3,
        private readonly npcSpawnService: NpcSpawnService,
    ) {}

    public spawn(world: World, onSpawned?: (cop: Npc, car: Car) => void): void {
        this.npcSpawnService.loader.load(CAR_MODEL_PATH, (carModel) => {
            const car = new Car(carModel);
            car.setPosition(this.position.x, this.position.y, this.position.z);
            world.add(car);

            const copModelPath = this.npcSpawnService.pickCopModel();
            this.npcSpawnService.loader.load(`../../${copModelPath}`, (copModel) => {
                const cop = new Npc(copModel, world.animationClips);
                cop.traverse((object) => { object.frustumCulled = false; });
                cop.isPlayer = false;
                world.add(cop);
                cop.teleportToVehicle(car, car.seats[0]);
                cop.setBehaviour(new CopCarBehaviour(world, car));
                onSpawned?.(cop, car);
            });
        });
    }
}
